import React from 'react';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <p>© 2024 Integrated ElectroMechanical Services Group Co. All rights reserved.</p>
      <ul className="footer-links">
        <li><a href="#facebook">Facebook</a></li>
        <li><a href="#linkedin">LinkedIn</a></li>
        <li><a href="#instagram">Instagram</a></li>
      </ul>
    </footer>
  );
}

export default Footer;
